import React from "react";

const AccordionUpIcon = ({ width = 16, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.52925 5.52827C7.7896 5.26792 8.21171 5.26792 8.47206 5.52827L12.4721 9.52827C12.7324 9.78862 12.7324 10.2107 12.4721 10.4711C12.2117 10.7314 11.7896 10.7314 11.5292 10.4711L8.00065 6.94248L4.47206 10.4711C4.21171 10.7314 3.7896 10.7314 3.52925 10.4711C3.2689 10.2107 3.2689 9.78862 3.52925 9.52827L7.52925 5.52827Z"
      fill="#4A4A4A"
    />
  </svg>
);
export default AccordionUpIcon;
